import { SVGProps } from 'react';

const SvgBilling = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
        <path d="M10 .167a3.335 3.335 0 0 0 0 6.666 3.335 3.335 0 0 0 0-6.666ZM10 5.5c-1.107 0-2-.894-2-2 0-1.107.893-2 2-2s2 .893 2 2c0 1.106-.893 2-2 2Zm2 4h-1.333c0-.8-.5-1.52-1.247-1.8L5.313 6.166H0V13.5h4v-.96l4.667 1.293L14 12.166V11.5c0-1.107-.893-2-2-2Zm-9.333 2.666H1.333V7.5h1.334v4.666Zm5.98.274L4 11.166V7.5h1.073l3.88 1.447c.227.086.38.306.38.553 0 0-1.333-.034-1.533-.1l-1.587-.527-.42 1.267 1.587.526c.34.114.693.167 1.053.167H12c.26 0 .493.16.6.38L8.647 12.44Z" />
    </svg>
);
export default SvgBilling;
